var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"test"},[_c('wx-open-launch-weapp',{attrs:{"id":"launch-btn","username":"gh_xxxxxxxx","path":"pages/home/index?user=123&action=abc"}},[[_c('button',{staticClass:"btn"},[_vm._v("打开小程序")])]],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }